module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWBAMAAAA2mnEIAAAABGdBTUEAALGPC/xhBQAAAB5QTFRFAAAA2NjYxc3VxszSxcvRxczSxszRxczSxszSxcvRAHvVEAAAAAl0Uk5TAA1Cgc/Q4PP+b35WCwAAAExJREFUGNNjYCAdMJqUOwtA2WozZ85MgjCZOoHsGQpgtthMEEgEsy3B7MlgdiSYPQXMrgSzp2OwPZHUIOtFNhPZLmQ3MDCaItxGCgAAM6srGq6u8ywAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/change-icon/e5_dot@2x.png
// module id = aRks
// module chunks = 1